/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kvagzuschuss3Inputs */



/**

* @param {_Field_Kvagzuschuss3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kvagzuschuss3 = /** @type {((inputs?: _Field_Kvagzuschuss3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kvagzuschuss3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("KV-AG-Zuschuss")
});
export { _field_kvagzuschuss3 as "_field_kvAGZuschuss" }